import React from 'react';

interface ISuccessSignIconProps {
  color?: string;
}

const SuccessSignIcon: React.FC<ISuccessSignIconProps> = props => {
  const { color } = props;
  return (
    <svg width="1.4em" height="1.1em" viewBox="0 0 14 11" fill="none">
      <path
        d="M13 1L4.75 9.25L1 5.5"
        stroke={`${color || 'white'}`}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SuccessSignIcon;
